/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import { bool, node, shape, string } from 'prop-types';
import React, { Component } from 'react';
import { Input } from 'semantic-ui-react';

import FieldLayout from '../FieldLayout/FieldLayout';

import styles from './input.less';

class InputField extends Component {
  handleChange = e => {
    const {
      field: { name },
      form: { setFieldValue },
      onlyTypeIntegerNumber,
      onlyTyNumberAndLetter,
    } = this.props;
    if (onlyTyNumberAndLetter && !/^[a-zA-Z0-9]+$/.test(e.target.value) && e.target.value !== '') {
      return;
    }
    if (onlyTypeIntegerNumber && !/^\d+$/.test(e.target.value) && e.target.value !== '') {
      return;
    }
    setFieldValue(name, e.target.value);
  };

  handleBlur = () => {
    const {
      field: { name },
      form: { setFieldTouched },
    } = this.props;
    setFieldTouched(name);
  };

  render() {
    const {
      field: { name, value },
      label,
      maxlengthchar,
      errorInline,
      customLabel,
      hint,
      ...props
    } = this.props;

    const error =
      value && value.length > +maxlengthchar
        ? `The maximum is ${maxlengthchar} characters long`
        : null;
    return (
      <FieldLayout name={name} label={label} errorInline={errorInline}>
        <Input
          value={value}
          onChange={this.handleChange}
          label={customLabel}
          onBlur={this.handleBlur}
          className={styles.input}
          {...props}
        />
        {hint && <span className={styles.hint}>{hint}</span>}
        {maxlengthchar && (
          <span className={error ? styles.countRed : styles.count}>
            {value ? maxlengthchar - value.length : maxlengthchar}
          </span>
        )}
      </FieldLayout>
    );
  }
}
InputField.propTypes = {
  field: shape({}).isRequired,
  label: string,
  hint: string,
  errorInline: bool,
  customLabel: node,
  onlyTypeIntegerNumber: bool,
  onlyTyNumberAndLetter: bool,
};

InputField.defaultProps = {
  label: '',
  hint: '',
  customLabel: null,
  errorInline: false,
  onlyTypeIntegerNumber: false,
  onlyTyNumberAndLetter: false,
};

export default InputField;
